import React from 'react';
import { IS_FEDERAL, CLASSIFICATION } from '@scale/frontend-lib/constants';

interface IFederalBannerProps {
  style?: React.CSSProperties;
}

const FederalBanner: React.FC<IFederalBannerProps> = props => {
  const { style } = props;

  if (!IS_FEDERAL) return <div></div>;

  let className = 'alert-header';
  if (CLASSIFICATION.includes('SECRET')) {
    className += ' red';
  }

  return (
    <div className={className} style={style}>
      {CLASSIFICATION}
      <style jsx>{`
        .alert-header {
          color: white;
          background: #006700;
          text-align: center;
          z-index: 1;
        }
        .red {
          background: #d00000;
        }
      `}</style>
    </div>
  );
};

export default FederalBanner;
